import ProductGeneralLedgerSettings from "@/models/Products/ProductSettings/ProductGeneralLedgerSettings";

export default class UpdateGeneralLedgerMappingsRequest extends ProductGeneralLedgerSettings {
    updatedAt: Date;

    public constructor(settings: ProductGeneralLedgerSettings, updatedAt: Date) {
        super();
        this.updatedAt = updatedAt;
        this.enabled = settings.enabled;
        this.overridable = undefined; // TECHDEBT: There is some redundancy here, ideally we shouldn't need to remove this overridable
        this.transactionSourceGLId = settings.transactionSourceGLId;
        this.savingsPortfolioControlGLId = settings.savingsPortfolioControlGLId;
        this.savingsInterestExpenseGLId = settings.savingsInterestExpenseGLId;
        this.savingsInterestPayableGLId = settings.savingsInterestPayableGLId;
        this.savingsFeeIncomeGLId = settings.savingsFeeIncomeGLId;
        this.state = settings.state;
    }
}